// extracted by mini-css-extract-plugin
export default {"main_container":"Dashboard_main_container__3pY-0"};